import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Story } from 'src/app/stories/models';
import { findNearest, getDistance } from 'geolib';

@Component({
  selector: 'app-story-card',
  templateUrl: './story-card.component.html',

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StoryCardComponent {
  @Input() story!: Story;
  @Input() location!: GeolocationPosition | undefined | null;
  @Input() label?: string;

  getDistance() {
    if (!this.location || !this.story.locations?.length) {
      return undefined;
    }
    const nearest = findNearest(
      [this.location.coords.latitude, this.location.coords.longitude],
      this.story.locations.map(l => [l.lat, l.lng])
    );
    return getDistance(nearest, [this.location.coords.latitude, this.location.coords.longitude]);
  }
}
